import { UseQueryOptions } from '@tanstack/react-query';
import { CuredApiPaths } from 'models/enums';
import useQuery from '../useQuery';
import QueryKeys from './keys';
import { Folder } from 'models/types';

type UseSegmentsWithFoldersParams = {
    folderId?: number;
    type?: string;
    searchTerm?: string;
    reactQueryOptions?: UseQueryOptions<Folder[], Error>;
};

const useSegmentsWithFolders = ({
    folderId = -1,
    type,
    searchTerm,
    reactQueryOptions,
}: UseSegmentsWithFoldersParams = {}) => {
    const axiosOptions = {
        ...(type && { params: { type } }),
        ...(searchTerm && { params: { ...(type && { type }), searchTerm } }),
    };

    const folderPath = folderId === -1 ? '' : `/${folderId}`;

    return useQuery(
        QueryKeys.SEGMENT_FOLDERS(folderId, type, searchTerm),
        `${CuredApiPaths.SEGMENT_FOLDERS}${folderPath}`,
        reactQueryOptions,
        axiosOptions
    );
};

export default useSegmentsWithFolders;
